import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import { Add, Remove, SentimentDissatisfied, SentimentSatisfiedAlt, SentimentVeryDissatisfied } from "@material-ui/icons"
import style from "./style.module.sass";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import config from "../../../../config"

export default function AccordionItem({
    children,
    index,
    windowsKey,
    handleTopAccordionOpen,
    color,
    number,
    title,
    filter,
    topColor
}) {
    const { theme: { bgColors, borderColors, colors } } = useTheme();
    const { t } = useTranslation();
    const topAccordionOpen = useSelector(state => state.analyseData.topAccordionOpen);
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const isTonality = windowsKey === 'Tonality'

    const handleChange = (panel) => (event, isExpanded) => {
        handleTopAccordionOpen(isExpanded ? panel : false);
    };

    return (
        <MuiAccordion expanded={topAccordionOpen === `${windowsKey}`} onChange={handleChange(`${windowsKey}`)} key={windowsKey} square>
            <MuiAccordionSummary expandIcon={
                (topAccordionOpen !== `${windowsKey}`) ? <Add style={{ fill: colors.colorText}}  /> : <Remove style={{ fill: colors.colorText}} />
            } style={{ borderTop: index !== 0 ? `1px solid ${borderColors.borderPrimary300}` : "none" }} data-accordion-item='accordion' tabIndex={config.tabIndexes.accordions[index]}>
                <div style={{ borderColor: borderColors.borderPrimary200 }} className={`${style.row} d-flex
                align-rows-center align-items-center ${topAccordionOpen === 0 && style.firstRow} ${topAccordionOpen === `${windowsKey}` &&
                    style.opened}`}>
                    {!isTonality && <div className={`${style.number} mr-2`} style={{ backgroundColor: !isContrast ? bgColors.bgPrimary200 : "transparent", width: isContrast ? "50px" : "40px" }}>
                        {!isContrast && <div style={{ backgroundColor: (title === t("Linguistic climate") ? "blue" : !!filter && !filter["red"] ? bgColors.bgYellow1000 : color )}} />}
                        {isContrast && (
                            title === t("Linguistic climate")
                                ? <div style={{ backgroundColor: bgColors.bgCockpitBar }} />
                                : !!filter && !filter["red"] 
                                 ? <SentimentDissatisfied style={{ fill: colors.colorIcons }} />
                                  : topColor === "red"
                                    ? <SentimentVeryDissatisfied style={{ fill: colors.colorIcons }} />
                                    : topColor === "yellow"
                                        ? <SentimentDissatisfied style={{ fill: colors.colorIcons }} />
                                        : <SentimentSatisfiedAlt style={{ fill: colors.colorIcons }} />
                        )}
                        <p style={{ color: colors.colorText, marginLeft: isContrast && "4px" }}>{number}{title === t('Linguistic climate') && "%"}</p>
                    </div>}
                    <span style={{ color: isContrast ? colors.colorText : topAccordionOpen === `${windowsKey}` ? colors.colorText : colors.colorMutedText }}
                        className={ isContrast ? `${style.title} m-1 ml-3` : `${style.title} m-0`} title={t(`accessibility_analysis_${windowsKey}`)}>{title}</span>
                </div>
            </MuiAccordionSummary>
            <MuiAccordionDetails>
                {children && children}
            </MuiAccordionDetails>
        </MuiAccordion>
    );

}
